import React from "react";

export default function SilenceOverviewPageFr() {
  return (
    <div
      style={{
        maxWidth: 700,
        margin: "48px auto",
        background: "#fff",
        borderRadius: 16,
        boxShadow: "0 2px 12px #0001",
        padding: 36,
        fontFamily: "inherit",
        color: "#222",
      }}
    >
      
      <h2 style={{ fontSize: 42, fontWeight: 900, color: "#006b44", margin: 0 }}>
        Surveillance du silence
      </h2>
      
      <p style={{ margin: "12px 0", lineHeight: 1.5 }}>
        Oubliez les « trous » inattendus à l'antenne. Notre service
        <b> surveille vos flux radio (MP3 et AAC+) 24/7</b>
        et vous avertit instantanément en cas de silence.
      </p>

      <ul style={{ paddingLeft: 18, margin: "14px 0" }}>
        <li style={{ marginBottom: 8 }}>
          Les alertes arrivent <b>sur Telegram</b> dès qu'un problème est détecté.
        </li>
        <li style={{ marginBottom: 8 }}>
          Vous pouvez ajouter <b>2 contacts supplémentaires</b>
          (par exemple l'équipe technique ou programmation) — inclus dans l'abonnement.
        </li>
        <li style={{ marginBottom: 8 }}>
          Vous disposez d'un <b>historique de 7 jours des niveaux sonores</b> pour chaque flux avec précision à la seconde — vous voyez toujours ce qu'il s'est passé à l'antenne.
        </li>
      </ul>

      <p style={{ margin: "12px 0", lineHeight: 1.5 }}>
        Connexion simple, sans équipement supplémentaire. Votre diffusion reste sous contrôle permanent.
      </p>
    </div>
  );
}
